/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const leadSlice = createSlice({
  name: 'lead',
  initialState: {
    allLeads: [],
    servicesAmount: null,
    creditCard: null,
    proposalData: null,
  },
  reducers: {
    setLeads: (state, action) => {
      state.allLeads = action.payload;
    },
    setCreditCard: (state, action) => {
      state.creditCard = action.payload;
    },
    setServicesAmount: (state, action) => {
      state.servicesAmount = {
        payrollTax: action.payload.payrollTax ?? state.servicesAmount?.payrollTax ?? 0,
        vatTax: action.payload.vatTax ?? state.servicesAmount?.vatTax ?? 0,
        corporateTax: action.payload.corporateTax ?? state.servicesAmount?.corporateTax ?? 0,
      };
    },

    setProposalData: (state, action) => {
      state.proposalData = action.payload;
    },
    setAddClient: (state, action) => {
      const newClient = action.payload
      const index = state.allLeads.findIndex(lead => lead?._id === newClient?._id)
      if (index !== -1) {
        state.allLeads[index] = newClient
      }
    },
    setUpdateStatus: (state, action) => {
      const newClient = action.payload
      const index = state.allLeads.findIndex(lead => {
        return lead?._id === newClient?._id
      })
      if (index !== -1) {
        state.allLeads[index] = newClient
      }
    },

  },
});

export const {
  setLeads, setAddClient, setServicesAmount, setCreditCard, setProposalData, setUpdateStatus
} = leadSlice.actions;

export default leadSlice.reducer;